var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      !_vm.newVisit
        ? [
            _vm.loading > 0
              ? [_c("Loader", { attrs: { delay: 0 } })]
              : [
                  _vm.visits.length > 0
                    ? _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          items: _vm.visits,
                          fields: _vm.table_fields
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "id_resultado_visita",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.parseResult(
                                        row.item.id_resultado_visita
                                      )
                                    ) +
                                    "\n        "
                                )
                              ]
                            }
                          },
                          {
                            key: "fecha_hora_visita",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.parseDateTime(
                                        row.item.fecha_hora_visita
                                      )
                                    ) +
                                    "\n        "
                                )
                              ]
                            }
                          },
                          {
                            key: "fecha_hora_proxima_visita",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.parseDateTime(
                                        row.item.fecha_hora_proxima_visita
                                      )
                                    ) +
                                    "\n        "
                                )
                              ]
                            }
                          },
                          {
                            key: "actions",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    attrs: { variant: "link", "no-caret": "" }
                                  },
                                  [
                                    _c("template", { slot: "button-content" }, [
                                      _c("i", {
                                        staticClass: "fa fa-ellipsis-v",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _vm.hasPermision("E")
                                      ? _c(
                                          "b-dropdown-item-button",
                                          {
                                            on: {
                                              click: function($event) {
                                                _vm.deleteVisit(row.item)
                                              }
                                            }
                                          },
                                          [_vm._v("Eliminar")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasPermision("E")
                                      ? _c(
                                          "b-dropdown-item-button",
                                          {
                                            on: {
                                              click: function($event) {
                                                _vm.editVisit(row.item)
                                              }
                                            }
                                          },
                                          [_vm._v("Editar")]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        ])
                      })
                    : [
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _c("strong", [
                            _vm._v("No se han encontrado visitas.")
                          ])
                        ])
                      ],
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _vm.hasPermision("E")
                        ? _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                { on: { click: _vm.createNewVisit } },
                                [_vm._v("Añadir visita")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
          ]
        : _vm.firstStep
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Código visitador" }
                          },
                          [
                            _c("b-form-select", {
                              staticClass: "mb-3",
                              attrs: {
                                options: _vm.users_options,
                                "text-field": "username",
                                "value-field": "username"
                              },
                              on: { input: _vm.updateUser },
                              model: {
                                value: _vm.currentUser,
                                callback: function($$v) {
                                  _vm.currentUser = $$v
                                },
                                expression: "currentUser"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Nombre visitador" }
                          },
                          [
                            _c("input", {
                              staticClass: "form-control",
                              attrs: { disabled: "" },
                              domProps: {
                                value:
                                  _vm.user.first_name + " " + _vm.user.last_name
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Visitado por gestor" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-control" },
                              [
                                _c("switches", {
                                  staticStyle: { "margin-top": ".5rem" },
                                  attrs: { color: "blue" },
                                  model: {
                                    value: _vm.visit.visitado_gestor,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.visit,
                                        "visitado_gestor",
                                        $$v
                                      )
                                    },
                                    expression: "visit.visitado_gestor"
                                  }
                                }),
                                _vm._v("\n               \n              "),
                                _vm.visit.visitado_gestor
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                Sí\n              "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                No\n              "
                                      )
                                    ])
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Status" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                name: "Status",
                                options: _vm.status_options,
                                "text-field": "visita_status",
                                "value-field": "visita_status"
                              },
                              model: {
                                value: _vm.visit.status_visita,
                                callback: function($$v) {
                                  _vm.$set(_vm.visit, "status_visita", $$v)
                                },
                                expression: "visit.status_visita"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Status")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Fecha y hora planificada" }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("datetime", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value:
                                        _vm.visit.status_visita ===
                                          "PLANIFICADA" ||
                                        _vm.visit.status_visita === "CANCELADA"
                                          ? "required"
                                          : "",
                                      expression:
                                        "(visit.status_visita === 'PLANIFICADA' || visit.status_visita === 'CANCELADA') ? 'required':''"
                                    }
                                  ],
                                  attrs: {
                                    name: "Fecha y hora planificada",
                                    "input-class": "form-control",
                                    phrases: { ok: "Ok", cancel: "Cancelar" },
                                    type: "datetime",
                                    auto: true,
                                    "minute-step": 15,
                                    "value-zone": "local",
                                    zone: "local"
                                  },
                                  model: {
                                    value: _vm.visit.fecha_hora_proxima_visita,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.visit,
                                        "fecha_hora_proxima_visita",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "visit.fecha_hora_proxima_visita"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-text",
                                  {
                                    attrs: { slot: "append" },
                                    on: {
                                      click: function($event) {
                                        _vm.visit.fecha_hora_proxima_visita = ""
                                      }
                                    },
                                    slot: "append"
                                  },
                                  [
                                    _c(
                                      "strong",
                                      { staticClass: "text-danger" },
                                      [_c("i", { staticClass: "fa fa-times" })]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("Fecha y hora planificada")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Fecha y hora finalizada" }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("datetime", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value:
                                        _vm.visit.status_visita === "FINALIZADA"
                                          ? "required"
                                          : "",
                                      expression:
                                        "(visit.status_visita === 'FINALIZADA') ? 'required':''"
                                    }
                                  ],
                                  attrs: {
                                    name: "Fecha y hora finalizada",
                                    "input-class": "form-control",
                                    phrases: { ok: "Ok", cancel: "Cancelar" },
                                    type: "datetime",
                                    auto: true,
                                    "minute-step": 15,
                                    "value-zone": "local",
                                    "max-datetime": _vm.currentDate,
                                    zone: "local"
                                  },
                                  model: {
                                    value: _vm.visit.fecha_hora_visita,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.visit,
                                        "fecha_hora_visita",
                                        $$v
                                      )
                                    },
                                    expression: "visit.fecha_hora_visita"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-text",
                                  {
                                    attrs: { slot: "append" },
                                    on: {
                                      click: function($event) {
                                        _vm.visit.fecha_hora_visita = ""
                                      }
                                    },
                                    slot: "append"
                                  },
                                  [
                                    _c(
                                      "strong",
                                      { staticClass: "text-danger" },
                                      [_c("i", { staticClass: "fa fa-times" })]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("Fecha y hora finalizada")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Tipo actividad" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                name: "Tipo actividad",
                                options: _vm.tipo_actividad_options,
                                "text-field": "descripcion",
                                "value-field": "descripcion"
                              },
                              model: {
                                value: _vm.visit.tipo_actividad,
                                callback: function($$v) {
                                  _vm.$set(_vm.visit, "tipo_actividad", $$v)
                                },
                                expression: "visit.tipo_actividad"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Tipo actividad")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Resultado" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value:
                                    _vm.visit.status_visita === "FINALIZADA"
                                      ? "required"
                                      : "",
                                  expression:
                                    "(visit.status_visita === 'FINALIZADA') ? 'required':''"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                name: "Resultado",
                                options: _vm.resultados_options,
                                "text-field": "resultado",
                                "value-field": "id"
                              },
                              model: {
                                value: _vm.visit.id_resultado_visita,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.visit,
                                    "id_resultado_visita",
                                    $$v
                                  )
                                },
                                expression: "visit.id_resultado_visita"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Resultado")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Observaciones" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.ObsValidate,
                                  expression: "ObsValidate"
                                }
                              ],
                              attrs: { name: "Observaciones" },
                              model: {
                                value: _vm.visit.observaciones,
                                callback: function($$v) {
                                  _vm.$set(_vm.visit, "observaciones", $$v)
                                },
                                expression: "visit.observaciones"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.first("Observaciones")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Invitados" }
                          },
                          [
                            _c("b-form-input", {
                              model: {
                                value: _vm.visit.invitados,
                                callback: function($$v) {
                                  _vm.$set(_vm.visit, "invitados", $$v)
                                },
                                expression: "visit.invitados"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Enviar email a invitados" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { target: "_top", href: _vm.mailText }
                              },
                              [_vm._v("Enviar")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _vm.hasPermision("E")
                  ? _c(
                      "b-col",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "b-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.newVisit = false
                              }
                            }
                          },
                          [_vm._v("Cancelar")]
                        ),
                        _vm._v(" "),
                        _c("b-button", { on: { click: _vm.saveStep } }, [
                          _vm._v("Guardar")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        : [
            _vm.loading > 0
              ? [_c("Loader", { attrs: { delay: 0 } })]
              : [
                  _c("h2", [
                    _vm._v("\n        Actualización datos gestión\n      ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticStyle: { "font-size": "1rem" },
                                  attrs: { label: "Clase establecimiento GN" }
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "mb-3",
                                    attrs: {
                                      name: "Clase establecimiento GN",
                                      options:
                                        _vm.clase_establecimiento_comercial_options,
                                      "text-field": "tipo",
                                      "value-field": "id"
                                    },
                                    model: {
                                      value:
                                        _vm.detalles[
                                          "id_clase_establecimiento_gn_" +
                                            _vm.type
                                        ].id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.detalles[
                                            "id_clase_establecimiento_gn_" +
                                              _vm.type
                                          ],
                                          "id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "detalles['id_clase_establecimiento_gn_'+type].id"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "Clase establecimiento GN"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticStyle: { "font-size": "1rem" },
                                  attrs: { label: "Es cliente" }
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.isRequired,
                                        expression: "isRequired"
                                      }
                                    ],
                                    staticClass: "mb-3",
                                    attrs: {
                                      name: "Es cliente",
                                      options: _vm.cliente_options,
                                      "text-field": "text",
                                      "value-field": "value",
                                      disabled: !_vm.hasPermision("E")
                                    },
                                    model: {
                                      value: _vm.detalles.cliente,
                                      callback: function($$v) {
                                        _vm.$set(_vm.detalles, "cliente", $$v)
                                      },
                                      expression: "detalles.cliente"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first("Es cliente"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.type === "comercial"
                        ? _c(
                            "b-col",
                            [
                              _c(
                                "b-form",
                                [
                                  _vm.type === "comercial"
                                    ? _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Gas en finca" }
                                        },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.checkGasEnFinca,
                                                expression: "checkGasEnFinca"
                                              }
                                            ],
                                            staticClass: "mb-3",
                                            attrs: {
                                              name: "Gas en finca",
                                              options: _vm.gas_options,
                                              "text-field": "gas",
                                              "value-field": "id",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.id_gas_finca.id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles.id_gas_finca,
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.id_gas_finca.id"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first("Gas en finca")
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.type === "caldera"
                                    ? _c(
                                        "b-form-group",
                                        {
                                          staticStyle: { "font-size": "1rem" },
                                          attrs: { label: "Gas en finca" }
                                        },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.checkGasEnFinca,
                                                expression: "checkGasEnFinca"
                                              }
                                            ],
                                            staticClass: "mb-3",
                                            attrs: {
                                              name: "Gas en finca",
                                              options: _vm.gas_options,
                                              "text-field": "gas",
                                              "value-field": "id",
                                              disabled: !_vm.hasPermision("E")
                                            },
                                            model: {
                                              value:
                                                _vm.detalles.id_gas_en_finca.id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalles.id_gas_en_finca,
                                                  "id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "detalles.id_gas_en_finca.id"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first("Gas en finca")
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticStyle: { "font-size": "1rem" },
                                  attrs: { label: "Status gestión" }
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "mb-3",
                                    attrs: {
                                      name: "Status gestión",
                                      options: _vm.status_gestion_options,
                                      "text-field": "status",
                                      "value-field": "id"
                                    },
                                    on: { input: _vm.updateDate },
                                    model: {
                                      value:
                                        _vm.detalles[
                                          "id_status_gestion_" + _vm.type
                                        ].id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.detalles[
                                            "id_status_gestion_" + _vm.type
                                          ],
                                          "id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "detalles['id_status_gestion_'+type].id"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first("Status gestión"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _vm.detalles["id_status_gestion_" + _vm.type].id === 5
                            ? _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Motivo rechazo" }
                                    },
                                    [
                                      _c("b-form-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass: "mb-3",
                                        attrs: {
                                          name: "Motivo rechazo",
                                          options: _vm.motivo_rechazo_options,
                                          "text-field": "motivo",
                                          "value-field": "motivo",
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value: _vm.detalles.motivo_rechazo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "motivo_rechazo",
                                              $$v
                                            )
                                          },
                                          expression: "detalles.motivo_rechazo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first("Motivo rechazo")
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm.detalles["id_status_gestion_" + _vm.type]
                                .id === 8
                            ? _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticStyle: { "font-size": "1rem" },
                                      attrs: { label: "Motivo no potencial" }
                                    },
                                    [
                                      _c("b-form-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass: "mb-3",
                                        attrs: {
                                          name: "Motivo no potencial",
                                          options:
                                            _vm.motivo_no_potencial_options,
                                          "text-field": "motivo",
                                          "value-field": "motivo",
                                          disabled: !_vm.hasPermision("E")
                                        },
                                        model: {
                                          value:
                                            _vm.detalles.motivo_no_potencial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.detalles,
                                              "motivo_no_potencial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "detalles.motivo_no_potencial"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              "Motivo no potencial"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _vm.hasPermision("E")
                        ? _c(
                            "b-col",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "b-button",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.firstStep = true
                                    }
                                  }
                                },
                                [_vm._v("Cancelar")]
                              ),
                              _vm._v(" "),
                              _c("b-button", { on: { click: _vm.saveVisit } }, [
                                _vm._v("Guardar")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details/comercial_visitas.vue?vue&type=template&id=51fe5fb5&
// module id = null
// module chunks = 